export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="8" fill="#0B0C0E" stroke="#2E333D" strokeWidth="2" />
    <path d="M14 14h36v9H25v18h14v-5h-8v-8h19v22H14z" fill="#FFFFFF" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" data-testid="nav-brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-2xl font-black tracking-tight text-[#F3F4F6]">
        GATIVAN<span className="text-[#FFFFFF]">.</span>
      </span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-[#9CA3AF]">
        Office · Est. 2019
      </span>
    </span>
  </span>
);
